import styled from 'styled-components';

import Image from '../Image';

export const StyledImage = styled(Image)`
  width: 100px;
  position: relative;
  top: 12px;
  img {
    margin-bottom: 0;
  }
`;
